/**
 * Application component
 *
 * To contain application wide settings, routes, state, etc.
 */

import React from "react";

import About from "./Components/About";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Home from "./Components/Home";

import "./styles.css";

/**
 * This object represents your information. The project is set so that you
 * only need to update these here, and values are passed a properties to the
 * components that need that information.
 *
 * Update the values below with your information.
 *
 * If you don't have one of the social sites listed, leave it as an empty string.
 */
const siteProps = {
  name: "Aldrin Aldino",
  title: "Informatics Engineer Student",
  email: "aldrinaldino4@gmail.com",
  gitHub: "arudorin",
  instagram: "aldrinaldino._",
  linkedIn: "",
  medium: "",
  twitter: "aldino_aldrin",
  youTube: "",
};

const primaryColor = "#262626";
const secondaryColor = "#FFFFFF";

const App = () => {
  return (
    <div id="main">
      <Header />
      <Home name={siteProps.name} title={siteProps.title} />
      <About />
      <Footer {...siteProps} primaryColor={primaryColor} secondaryColor={secondaryColor} />
    </div>
  );
};

export default App;
